import http from '@/utils/http'  //引入axios
export  const getTrans= data=>http.get('/rvm-center/api/check/trans',{params:data}) //查找交易记录
export  const checkTrans = data =>http.post('/rvm-center/api/check/bylist',data)
export const checkDayTrans = data => http.get('/rvm-center/api/check/bydate',{params:data})
// export  const findBarcode = data=>http.get('/api/district/superior',{params:data}) //查找部门
export default{
    getTrans,
    checkTrans,
    checkDayTrans
}